import React from 'react';

import { ToggleButton } from '@mui/material';

import ToolbarToggleInput from '../base/ToolbarToggleInput';

type Props = {
  label: string;
  name: string;
};
export default function FontWeight({ label, name }: Props) {
  return (
    <ToolbarToggleInput label={label} name={name}>
      <ToggleButton value="normal">Regular</ToggleButton>
      <ToggleButton value="bold">Bold</ToggleButton>
    </ToolbarToggleInput>
  );
}
